export const PERMISSION_NAME_GEOLOCATION = 'geolocation';
export const PERMISSION_STATE_GRANTED = 'granted';
export const PERMISSION_STATE_DENIED = 'denied';
export const ERROR_GEOLOCATION_NOT_SUPPORTED = 'Geolocation is not supported by your browser.';
export const GEOLOCATION_TIMEOUT_MS = 15000;
